import { useState } from 'react';
import { Check, Copy, ExternalLink, Monitor } from 'lucide-react';

export default function DisplaySetup({
  externalMap,
  onExternalMap,
}: {
  externalMap: boolean;
  onExternalMap: (value: boolean) => void;
}) {
  const url = new URL('/leitstelle/karte', window.location.origin).href;
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState('');
  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setError('');
    } catch {
      setError('Bitte den Link im Feld markieren und kopieren.');
    }
  }
  return (
    <div className="dialog-stack display-setup">
      <div className="display-intro">
        <Monitor size={32} />
        <p>
          Die Lagekarte läuft auf einem eigenen Bildschirm. Einsätze, Straßenrouten und
          Fahrzeugbewegungen werden mit deinem PC synchronisiert.
        </p>
      </div>
      <ol>
        <li>Öffne den Link im Browser auf deinem Tablet, Fernseher oder zweiten Monitor.</li>
        <li>
          Melde dich dort mit <b>demselben Spielerkonto</b> wie am PC an.
        </li>
        <li>
          Am PC disponieren, auf dem zweiten Gerät die Lage verfolgen. Dort kannst du Vollbild und
          „PC-Auswahl folgen“ einschalten.
        </li>
      </ol>
      <label>
        Kartenbildschirm-Link
        <input
          aria-label="Kartenbildschirm-Link"
          value={url}
          readOnly
          onFocus={(event) => event.target.select()}
        />
      </label>
      <div className="display-actions">
        <a
          className="button primary"
          href="/leitstelle/karte"
          target="_blank"
          rel="noopener noreferrer"
        >
          <ExternalLink size={17} /> Karte in neuem Tab öffnen
        </a>
        <button className="button secondary" onClick={() => void copy()}>
          {copied ? <Check size={16} /> : <Copy size={16} />}
          {copied ? 'Link kopiert' : 'Link kopieren'}
        </button>
      </div>
      <label className="switch-row">
        <span>
          Karte an diesem Arbeitsplatz ausblenden
          <small>
            Hier die Einsatzliste und Disposition nutzen; die Karte bleibt auf dem zweiten Gerät
            sichtbar.
          </small>
        </span>
        <input
          type="checkbox"
          checked={externalMap}
          onChange={(event) => onExternalMap(event.target.checked)}
        />
      </label>
      <p className="muted">
        Der Link enthält keine Zugangsdaten. Beide Geräte benötigen Internetzugang zu 112base.de.
        Ein gemeinsames WLAN ist nicht erforderlich.
      </p>
      {error && <p role="status">{error}</p>}
    </div>
  );
}
